import { render } from "./ResponseUnits.vue?vue&type=template&id=3468ed6f&scoped=true"
import script from "./ResponseUnits.vue?vue&type=script&lang=js"
export * from "./ResponseUnits.vue?vue&type=script&lang=js"

import "./ResponseUnits.vue?vue&type=style&index=0&id=3468ed6f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3468ed6f"]])

export default __exports__